//-------------------------------
// is current characteristic max
//-------------------------------
export default function isCurCharMax(parm) {
  // console.log("----------------------");
  // console.log("IN isCurCharMax");
  // console.log("PARM = ", parm)

  const max = Number(parm.max) || 0;
  const cur = Number(parm.cur) || 0;
  const integs_tot = Number(parm.integs_tot) || 0;

  let result;
  if ('integs_tot' in parm) {
    result = max - integs_tot;
  } else {
    result = max;
  }

  if (cur >= result) {
    return true
  }
  return false
}